import { ComponentType, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';
import { ModalRef } from '@atsystems/ui';

@Injectable()
export class SpotlightService {
  private currentOverlayRef: OverlayRef | null = null;

  constructor(private overlay: Overlay, private injector: Injector) {}

  open<T>(component: ComponentType<T>): ModalRef | undefined {
    if (this.currentOverlayRef) {
      this.currentOverlayRef.dispose();
      this.currentOverlayRef = null;
      return;
    }

    const positionStrategy = this.overlay
      .position()
      .global()
      .centerHorizontally()
      .top('10vh');

    const overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: false,
    });

    this.currentOverlayRef = overlayRef;

    const dialogRef = new ModalRef(overlayRef);

    overlayRef.detachments().subscribe(() => {
      this.currentOverlayRef = null;
    });

    const injector = Injector.create({
      parent: this.injector,
      providers: [
        { provide: ModalRef, useValue: dialogRef },
      ],
    });

    const portal = new ComponentPortal(component, null, injector);
    overlayRef.attach(portal);

    return dialogRef;
  }
}
